
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.05 33.834c6.517 0 11.8-5.283 11.8-11.8s-5.283-11.8-11.8-11.8-11.8 5.283-11.8 11.8 5.283 11.8 11.8 11.8z","fill":"#FFDC70"}}),_c('path',{attrs:{"d":"M36.432 36.432l9.693 9.693","stroke":"#000","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.525 42.193c10.862 0 19.667-8.805 19.667-19.667 0-10.862-8.805-19.667-19.667-19.667-10.861 0-19.667 8.805-19.667 19.667 0 10.862 8.806 19.667 19.667 19.667z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M27.196 17.671a4.67 4.67 0 11-9.341 0 4.67 4.67 0 019.341 0zM31.867 32.85c-.538-4.6-4.514-8.174-9.342-8.174s-8.804 3.573-9.341 8.174h18.683z","stroke":"#000"}})])
          )
        }
      }
    